import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProgramService, PartService } from '../../../phf.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { UploadService } from '../upload-service';
import { UploadComponent } from '../upload.component';
import { PartGrid } from '../../../../../../../src/app/components/phf/administration/upload/part-grid'
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'select-program',
  templateUrl: './select-program.component.html',
  styleUrls: ['./select-program.component.scss']
})

export class SelectProgramComponent implements OnInit {
  @Input() show = false;
  @Output()
  save: EventEmitter<any> = new EventEmitter();
  @Output()
  close: EventEmitter<any> = new EventEmitter();

  part: any;
  editForm: FormGroup;
  opened: boolean;

  constructor(
    private readonly formBuilder: FormBuilder,
    public programService: ProgramService,
    ) {
    this.programService.read();
  }
  
  ngOnInit() {
    this.editForm = this.formBuilder.group(editForm);
  }

  /**
   * Handles the action when apply button is clicked
  */
  onSave() {
    this.save.emit(this.editForm.get('Program').value)
    this.show = false;
    this.onClose();
  }

  onClose() {
    this.close.emit();
    this.opened = false;
  }
}
const editForm = {
  Program: [],
}
